"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Sidebar/CampaignsList/CampaignItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _types = require('./types');
var _broadcast = require('shared/selectors/broadcast');
var _team = require('shared/selectors/team');
var _hooks = require('web/services/hooks');

var _Avatar = require('web/components/Avatar');
var _CampaignStatus = require('web/screens/Broadcast/CampaignStatus'); var _CampaignStatus2 = _interopRequireDefault(_CampaignStatus);
var _useArchiveCampaign = require('web/screens/Broadcast/useArchiveCampaign'); var _useArchiveCampaign2 = _interopRequireDefault(_useArchiveCampaign);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _DisabledReason = require('web/screens/Broadcast/DisabledReason'); var _DisabledReason2 = _interopRequireDefault(_DisabledReason);
var _TeamBadge = require('./TeamBadge'); var _TeamBadge2 = _interopRequireDefault(_TeamBadge);
var _keyboard = require('web/services/keyboard');








const CampaignItem = ({
  campaignKey,
  activeFilter,
  isViewed,
  onClick,
}) => {
  // One primitive per selector, so the row re-renders only when a field it
  // shows changes (not on every campaign update, e.g. Stats).
  const campaignName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_broadcast.selectCampaignByKey.call(void 0, state, campaignKey), 'optionalAccess', _ => _.Name]), () => ( '')))
  const isCampaignActive = _hooks.useAppSelector.call(void 0, state => !!_optionalChain([_broadcast.selectCampaignByKey.call(void 0, state, campaignKey), 'optionalAccess', _2 => _2.Active]))
  const isCampaignArchived = _hooks.useAppSelector.call(void 0, 
    state => !!_optionalChain([_broadcast.selectCampaignByKey.call(void 0, state, campaignKey), 'optionalAccess', _3 => _3.Archived]),
  )
  const teamName = _hooks.useAppSelector.call(void 0, state => {
    const campaign = _broadcast.selectCampaignByKey.call(void 0, state, campaignKey)
    return _optionalChain([campaign, 'optionalAccess', _4 => _4.TeamKey])
      ? _nullishCoalesce(_optionalChain([_team.selectTeamByKey.call(void 0, state, campaign.TeamKey), 'optionalAccess', _5 => _5.Name]), () => ( ''))
      : ''
  })

  const { onArchive, onUnarchive, confirmModal, archiveBlockedReason } = _useArchiveCampaign2.default.call(void 0, campaignKey)
  const isArchiveBlocked = !isCampaignArchived && !!archiveBlockedReason
  if (activeFilter === _types.Filter.active
    ? isCampaignArchived
    : !isCampaignArchived
  ) return null

  // The modal sits outside the row: a click in it would bubble to onClick.
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  confirmModal 
      , _react2.default.createElement('div', {
        onClick: onClick,
        role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
        className: _classBuilder2.default.call(void 0, 
          "broadcast-list--campaign",
          isViewed && "broadcast-list--campaign--viewed",
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}

        , _react2.default.createElement('div', { className: "broadcast-list--campaign--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          , _react2.default.createElement(_Avatar.CampaignAvatar, {
            size: 44,
            campaignKey: campaignKey,
            className: "broadcast-list--campaign-avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
          )
          , _react2.default.createElement('div', { className: "broadcast-list--campaign-info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
            , _react2.default.createElement('span', { className: "broadcast-list--campaign-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}},  campaignName )
            , _react2.default.createElement(_CampaignStatus2.default, {
              campaignKey: campaignKey,
              className: "broadcast-list--campaign-desc",
              isCompact: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
            )
            , _react2.default.createElement(_TeamBadge2.default, { name: teamName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}} )
          )
          ,  (isCampaignArchived || !isCampaignActive) && (
            _react2.default.createElement(_DisabledReason2.default, { reason: isArchiveBlocked ? archiveBlockedReason : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
              , _react2.default.createElement('div', {
                role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
                'aria-disabled': isArchiveBlocked || undefined,
                className: _classBuilder2.default.call(void 0, 
                  "broadcast-list--campaign-action",
                  isArchiveBlocked && "broadcast-list--campaign-action--disabled",
                ),
                onClick: e => {
                  e.stopPropagation()
                  if (isCampaignArchived) onUnarchive()
                  else onArchive()
                }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}

                , _react2.default.createElement('div', { className: "broadcast-list--campaign-action--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}} )
                ,  isCampaignArchived ? 'Unarchive' : 'Archive' 
              )
            )
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, CampaignItem)
